module.exports = __webpack_public_path__ + "static/img/about_dnn_1.60bc46dd.png";